/* BEAHATER Popup Keyboard-Fix (2026-07-13)
   Zweck: Am Handy verdeckt die Tastatur das E-Mail-Feld + den Submit-Button des
   Newsletter-Popups (Overlay #bh-popup-overlay ist ein Bottom-Sheet, align-items:flex-end).
   Fix: (1) Nach "JA, BIN DABEI" bekommt das E-Mail-Feld sofort den Fokus.
        (2) Sobald das Feld fokussiert ist (nur mobil) bzw. die Tastatur aufgeht,
            wandert die Karte nach oben (align-items:flex-start) und bleibt sichtbar.
   Separates Asset mit Absicht: sections/newsletter-popup.liquid ist geschuetzt und
   bleibt unveraendert. Dieses Script greift nur lesend auf dessen DOM zu, no-op bei Fehlern. */
(function () {
  'use strict';
  try {
    var MOBILE_MAX = 700;   // px: nur unterhalb greift der Hochschieber
    var KB_MIN_SHRINK = 140; // px: visualViewport-Schrumpfung, die als Tastatur gilt

    function init() {
      var overlay = document.getElementById('bh-popup-overlay');
      if (!overlay) return;
      var input = overlay.querySelector('.bh-popup-input');
      var yesBtn = document.getElementById('bh-popup-yes-btn');
      if (!input) return;

      var raised = false;
      function raise(on) {
        if (on === raised) return;
        raised = on;
        try {
          if (on) {
            overlay.style.setProperty('align-items', 'flex-start', 'important');
            overlay.style.setProperty('padding-top', '12px', 'important');
          } else {
            overlay.style.removeProperty('align-items');
            overlay.style.removeProperty('padding-top');
          }
        } catch (e) {}
      }
      function isMobile() { return window.innerWidth < MOBILE_MAX; }

      // (1) Auto-Fokus nach JA — synchron im selben Tap, damit iOS die Tastatur oeffnet.
      if (yesBtn) {
        yesBtn.addEventListener('click', function () {
          try {
            if (input.offsetParent) { input.focus(); }
            else { setTimeout(function () { try { input.focus(); } catch (e) {} }, 120); }
          } catch (e) {}
        });
      }

      // (2a) Fokus am Handy -> Karte nach oben; Blur -> mit Verzoegerung zurueck
      //      (Verzoegerung, damit ein Tap auf den Submit-Button nicht ins Leere geht).
      input.addEventListener('focus', function () { if (isMobile()) raise(true); });
      input.addEventListener('blur', function () { setTimeout(function () { raise(false); }, 250); });

      // (2b) Sicherheitsnetz: echte Tastatur-Erkennung ueber visualViewport.
      if (window.visualViewport) {
        var maxH = window.visualViewport.height;
        window.visualViewport.addEventListener('resize', function () {
          try {
            var vv = window.visualViewport;
            if (vv.height > maxH) maxH = vv.height;
            var kbOpen = (maxH - vv.height) > KB_MIN_SHRINK;
            if (kbOpen && overlay.contains(document.activeElement)) raise(true);
            if (!kbOpen) raise(false);
          } catch (e) {}
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (e) { /* niemals den Shop stoeren */ }
})();
